/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { ReceiptResponseDto } from './ReceiptResponseDto';
import {
    ReceiptResponseDtoFromJSON,
    ReceiptResponseDtoFromJSONTyped,
    ReceiptResponseDtoToJSON,
    ReceiptResponseDtoToJSONTyped,
} from './ReceiptResponseDto';

/**
 * 
 * @export
 * @interface ReceiptPaginationResponseDto
 */
export interface ReceiptPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof ReceiptPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<ReceiptResponseDto>}
     * @memberof ReceiptPaginationResponseDto
     */
    items: Array<ReceiptResponseDto>;
}

/**
 * Check if a given object implements the ReceiptPaginationResponseDto interface.
 */
export function instanceOfReceiptPaginationResponseDto(value: object): value is ReceiptPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ReceiptPaginationResponseDtoFromJSON(json: any): ReceiptPaginationResponseDto {
    return ReceiptPaginationResponseDtoFromJSONTyped(json, false);
}

export function ReceiptPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(ReceiptResponseDtoFromJSON)),
    };
}

export function ReceiptPaginationResponseDtoToJSON(json: any): ReceiptPaginationResponseDto {
    return ReceiptPaginationResponseDtoToJSONTyped(json, false);
}

export function ReceiptPaginationResponseDtoToJSONTyped(value?: ReceiptPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(ReceiptResponseDtoToJSON)),
    };
}

